<template>
  <div class="full-loader">
    <div class="full-loader__overlay"></div>
    <div class="full-loader__info">
      <logo :centered="true" />
      <div class="full-loader__text">
        Загрузка системы...
      </div>
      <div class="full-loader__spinner">
        <spin size="large" />
      </div>
    </div>
  </div>
</template>

<script>
import Logo from '@/components/logo/logo'
export default {
  components: {
    Logo
  }
}
</script>

<style lang="less">
.full-loader {
  width: 100vw;
  height: 100vh;
  background-color: #232b38;
  z-index: 1000;
  background-image: url("../../assets/bg_dark.jpg");
  background-size: cover;
  background-position: 50% 50%;
  position: relative;

  &__overlay {
    position: absolute;
    top: 0;
    left: 0;
    right: 0;
    bottom: 0;
    background-color: rgba(#232b38, 0.6);
  }

  &__info {
    position: absolute;
    top: 50%;
    left: 50%;
    transform: translate(-50%, -50%);

    .app-logo {
      &__icon {
        font-size: 48px !important;
      }
      &__text {
        font-size: 28px;
      }
    }
  }

  &__text {
    text-align: center;
    margin-top: 16px;
    font-size: 16px;
    color: #fff;
  }

  &__spinner {
    text-align: center;
    margin-top: 16px;

    .ivu-spin {
      height: 100%;
    }
    .ivu-spin-main {
      height: 100%;
      display: flex;
      justify-content: center;
      align-items: center;
    }
  }
}
</style>
